import {
  ArpMedia,
  ArpMediaType,
  PaginatedResponse,
  PaginationParams,
  QueryParams
} from '@arpeggi/shared'
import { useAuth } from '../../hooks/useAuth'
import axios from '../../lib/axios'

export type Parts = Array<keyof Pick<ArpMedia, 'subComponents'>>

export interface GetFavoritesParams extends Omit<PaginationParams<ArpMedia>, 'orderBy'> {
  type?: ArpMediaType
  [QueryParams.PARTS]?: Parts
}

export const getUserFavorites = async (walletAddress: string, params?: GetFavoritesParams) => {
  const { data } = await axios.get<PaginatedResponse<ArpMedia>>(
    `/api/v2/users/${walletAddress}/arp-media-favorites`,
    { params }
  )
  return data
}

export const useArpFavoritesAPI = () => {
  const { authenticatedPost, authenticatedDelete } = useAuth()

  const createUserFavorite = async (arpMediaId: number) => {
    return authenticatedPost(`/api/v2/arp-media/${arpMediaId}/favorites`)
  }

  const deleteUserFavorite = async (arpMediaId: number) => {
    return authenticatedDelete(`/api/v2/arp-media/${arpMediaId}/favorites`)
  }

  return { getUserFavorites, createUserFavorite, deleteUserFavorite }
}
